import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import styles from 'styles';
import { types as TYPES_BY_PURPOSE } from 'constants/vesselTypes';

const getDate = (type) => {
    const date = new Date();
    switch (type) {
    case 'week': date.setDate(date.getDate() - 7); return date;
    case 'month': date.setMonth(date.getMonth() - 1); return date;
    case 'year': date.setFullYear(date.getFullYear() - 1); return date;
    default: return date;
    }
};

const exclusionsAndRestrictions = [
    { date: undefined, label: '' },
    { date: getDate('week'), label: 'Last Week' },
    { date: getDate('month'), label: 'Last Month' },
    { date: getDate('year'), label: 'Last Year' },
];

export default function VesselsListFilters({
    searchRef,
    defaultSearchValue,
    clearSearch,
    handleSearch,
    isNameSuggestion,
    notConfirmed,
    handleNameSuggested,
    handleConfirmed,
    modifiedFilter,
    handleFilters,
    filterCargoExclusions,
    filterTradingRestrictions,
    handleExclusions,
    photosFilter,
    sanctioned,
    handleSanctioned,
    rightPart,
    typeByPurpose, dwtMin, dwtMax, sortValue, sortField,
}) {
    return (
        <React.Fragment>
            <div className='table-header'>
                <div className='item'>
                    <div className="center-xs middle-xs" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                        <TextField
                            defaultValue={defaultSearchValue}
                            floatingLabelText="Search by imonumber or name"
                            ref={searchRef}
                            style={{ minWidth: '100px' }}
                            onChange={clearSearch}
                            onKeyPress={(event) => {
                                if (event.charCode === 13) {
                                    event.preventDefault();
                                    handleSearch();
                                }
                            }}
                        />
                        <RaisedButton
                            label="Search"
                            style={styles.RaisedButton}
                            primary
                            onClick={handleSearch}
                        />
                        <Checkbox
                            label="Not confirmed"
                            checked={notConfirmed}
                            onCheck={handleConfirmed}
                            style={{
                                display: 'inline-block', margin: '0 0 0 10px', width: '160px', textAlign: 'start', 
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <Checkbox
                            label="Rename suggestion"
                            checked={isNameSuggestion}
                            onCheck={handleNameSuggested}
                            style={{
                                display: 'inline-block', margin: '0 0 0 10px', width: '160px', textAlign: 'start', 
                            }}
                            labelStyle={{ fontSize: '13px', width: '100%' }}
                        />
                    </div>
                </div>
                <div className='item'>
                    {rightPart}
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ position: 'relative', marginRight: '10px' }}>
                        <SelectField
                            floatingLabelText="Modified"
                            floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                            value={modifiedFilter}
                            onChange={(_ev, _idx, val) => handleFilters('modifiedFilter', val)}
                            style={{
                                marginTop: '-10px', width: '150px', textAlign: 'left', fontSize: '13px', 
                            }}
                        >
                            <MenuItem value="all" primaryText="All" />
                            <MenuItem value="modified" primaryText="Modified" />
                            <MenuItem value="notModified" primaryText="Not modified" />
                        </SelectField>
                    </div>
                    <div style={{ position: 'relative', marginRight: '10px' }}>
                        <SelectField
                            floatingLabelText="Photos"
                            floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                            value={photosFilter}
                            onChange={(_ev, _idx, val) => handleFilters('photosFilter', val)}
                            style={{
                                marginTop: '-10px', width: '150px', textAlign: 'left', fontSize: '13px', 
                            }}
                        >
                            <MenuItem value="all" primaryText="All" />
                            <MenuItem value="withPhotos" primaryText="With photos" />
                            <MenuItem value="withoutPhotos" primaryText="Without photos" />
                        </SelectField>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <span style={{ fontSize: '13px', position: 'absolute' }}>Cargo exclusions</span>
                        <SelectField
                            floatingLabelText="Last updated"
                            floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                            value={filterCargoExclusions}
                            onChange={(_ev, _idx, val) => handleExclusions(val, 'filterCargoExclusions')}
                            style={{ marginTop: '-10px', width: '150px', textAlign: 'left' }}
                        >
                            {exclusionsAndRestrictions.map((excl, idx) => (
                                <MenuItem key={idx} value={excl.date ? excl.date.toISOString() : undefined} primaryText={excl.label} />
                            ))}
                        </SelectField>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <span style={{ fontSize: '13px', marginLeft: '10px', position: 'absolute' }}>Trading restrictions</span>
                        <SelectField
                            floatingLabelText="Last updated"
                            floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                            value={filterTradingRestrictions}
                            onChange={(_ev, _idx, val) => handleExclusions(val, 'filterTradingRestrictions')}
                            style={{
                                marginTop: '-10px', marginLeft: '10px', width: '150px', textAlign: 'left', 
                            }}
                        >
                            {exclusionsAndRestrictions.map((excl, idx) => (
                                <MenuItem key={idx} value={excl.date ? excl.date.toISOString() : undefined} primaryText={excl.label} />
                            ))}
                        </SelectField>
                    </div>
                    <Checkbox
                        label="Sanctioned"
                        checked={sanctioned}
                        onCheck={handleSanctioned}
                        style={{
                            display: 'inline-block', margin: '0 0 0 10px', width: '160px', textAlign: 'start', 
                        }}
                        labelStyle={{ fontSize: '13px' }}
                    />
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                    <SelectField
                        floatingLabelText="Type by purpose"
                        floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                        value={typeByPurpose || ''}
                        onChange={(_e, _i, val) => handleFilters('typeByPurpose', val || '')}
                        style={{ width: 160, textAlign: 'left' }}
                    >
                        <MenuItem value="" primaryText="" />
                        {TYPES_BY_PURPOSE.map(tp => <MenuItem key={tp} value={tp} primaryText={tp} />)}
                    </SelectField>

                    <TextField
                        floatingLabelText="DWT min"
                        type="number"
                        value={dwtMin || ''}
                        onChange={(_e, v) => handleFilters('dwtMin', v === '' ? null : Number(v))}
                        style={{ width: 120, fontSize: '13px' }}
                        inputStyle={{ textAlign: 'left' }}
                    />
                    <TextField
                        floatingLabelText="DWT max"
                        type="number"
                        value={dwtMax || ''}
                        onChange={(_e, v) => handleFilters('dwtMax', v === '' ? null : Number(v))}
                        style={{ width: 120, fontSize: '13px' }}
                        inputStyle={{ textAlign: 'left' }}
                    />

                    <SelectField
                        floatingLabelText="Sort BLT"
                        floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                        value={sortField === 'blt' ? sortValue : null}
                        onChange={(_e, _i, val) => {
                            const isBlank = val == null;
                            handleFilters({ sortField: isBlank ? undefined : 'blt', sortValue: isBlank ? undefined : val });
                        }}
                        style={{ width: 150, textAlign: 'left', fontSize: '13px' }}
                    >
                        <MenuItem value={null} primaryText="" />
                        <MenuItem value={-1} primaryText="Newest first" />
                        <MenuItem value={1} primaryText="Oldest first" />
                    </SelectField>
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Filters.jsx